import "./instrument"
import * as Sentry from "@sentry/react"
import ReactDOM from "react-dom/client"
import { Provider } from "react-redux"
import { store, persistor } from "./app/store"
import App from "./App"
import "./index.css"
import { BrowserRouter } from "react-router-dom"
import { PersistGate } from "redux-persist/integration/react"
import initializeGTM from "./libs/gtm"

initializeGTM()

ReactDOM.createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary>
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </BrowserRouter>
  </Sentry.ErrorBoundary>,
)
